import { useEffect, useState } from 'react';

const KEY = 'nwl:activeLocation';
const EVT = 'nwl:activeLocation-updated';

export const setActiveLocationId = (id: string | number | null | undefined) => {
 const next =
    id == null || id === '' || id === 'undefined' || id === 'null'
      ? null
      : String(id);

  if (next == null) localStorage.removeItem(KEY);
  else localStorage.setItem(KEY, next);

  window.dispatchEvent(new CustomEvent(EVT, { detail: next }));
};

export const useActiveLocationId = () => {
  const [id, setId] = useState<string | null>(() => localStorage.getItem(KEY));

  useEffect(() => {
    const onStorage = (e: StorageEvent) => {
      if (e.key === KEY) setId(localStorage.getItem(KEY));
    };
    const onCustom = (e: any) => setId(e?.detail ?? localStorage.getItem(KEY));

    window.addEventListener('storage', onStorage);
    window.addEventListener(EVT, onCustom);
    return () => {
      window.removeEventListener('storage', onStorage);
      window.removeEventListener(EVT, onCustom);
    };
  }, []);

  return id;
};
